import http from "../http";
import api from "../../config/api";
import { MedicalCalculatorsResponse } from "../../interfaces/api/congresses";

/**
 * Reports API service
 */
const congresses = {
  /**
   * Get medical calculators
   * @returns {Promise<FormsResponse>} API response
   */
  getMedicalCalculators: (): Promise<MedicalCalculatorsResponse> =>
    http.get(api.medicalCalculators),
};

export default congresses;
